<template>
  <div class="page">
    <nav-bar />
    <migration />
    <div class="page__wrapper">
      <div class="home__header">
        <p class="home__top__template_name">
          Шаблон «{{
            $store.state.page.template.display_name
              ? $store.state.page.template.display_name
              : templateConstructorData.display_name
          }}»
        </p>
        <h1 class="home__top__title">
          Управление страницей
        </h1>
      </div>
      <div class="home">
        <div
          class="home__top"
          :class="[
            `home__top--${
              template.name ? template.name : templateConstructorData.name
            }`
          ]"
          :style="{
            'background-image': `url(
              ${
                template.cover ? template.cover : templateCoverConstructorData
              })`
          }"
        >
          <div class="home__top__header"></div>
          <button
            v-if="isMobile"
            class="pBtn pBtn--blue"
            @click="
              () => {
                $router.push('/edit');
                this.GAEvent('profile_edit');
              }
            "
          >
            Редактировать
          </button>
          <button
            v-if="!isTablet && !isMobile"
            class="pBtn pBtn--grey-2"
            @click="
              () => {
                $router.push('/statistics');
                this.GAEvent(
                  'statistics_page',
                  'statistics_click',
                  '/statistics'
                );
              }
            "
          >
            <svg-icon type="statistics" />
            Статистика
          </button>
        </div>
        <div
          class="home__middle"
          :class="{ 'home__middle--unpublished': published }"
        >
          <button
            v-if="!isMobile"
            class="pBtn pBtn--blue"
            @click="
              () => {
                $router.push('/edit');
                this.GAEvent('profile_edit');
              }
            "
          >
            Редактировать
          </button>
          <button
            v-if="isTablet"
            class="pBtn pBtn--grey-2"
            @click="
              () => {
                $router.push('/statistics');
                this.GAEvent(
                  'statistics_page',
                  'statistics_click',
                  '/statistics'
                );
              }
            "
          >
            <svg-icon type="statistics" />
            Статистика
          </button>
          <div class="home__link">
            <div class="home__link__place">
              {{ pageBaseUrl + "/" + $store.state.page.url }}
              <span
                v-if="isMobile"
                class="home__icon_copy"
                @click="
                  () => {
                    copy(pageBaseUrl + '/' + $store.state.page.url);
                    this.GAEvent('profile_copy');
                  }
                "
                ><svg-icon type="copy-white"
              /></span>
            </div>
            <div
              class="home__copy"
              v-if="!isMobile"
              @click="
                () => {
                  copy(pageBaseUrl + '/' + $store.state.page.url);
                  this.GAEvent('profile_copy');
                }
              "
            >
              <svg-icon type="copy-white" />
              Копировать
            </div>
          </div>
          <div class="home__published">
            <CSwitch v-model="published" />
            {{ published ? "Не опубликована" : "Опубликована" }}
          </div>
        </div>
        <div v-if="isMobile" class="home__sub_mid">
          <button
            class="pBtn pBtn--grey-2"
            @click="
              () => {
                $router.push('/statistics');
                this.GAEvent(
                  'statistics_page',
                  'statistics_click',
                  '/statistics'
                );
              }
            "
          >
            <svg-icon type="statistics" />
            Статистика
          </button>
        </div>
        <div class="home__bottom">
          <div class="home__bottom__items">
            <div class="home__bottom__item">
              <div class="home__bottom__item__left">
                <h3 class="home__bottom__title">Контакты</h3>
                <span
                  class="home__bottom__link"
                  @click="
                    () => {
                      $router.push('/edit/profile');
                      this.GAEvent('contacts_edit');
                    }
                  "
                  >Редактировать</span
                >
              </div>
              <div class="home__bottom__item__right">
                <img class="home__avatar" :src="imgLink" />
              </div>
            </div>
            <div class="home__bottom__item">
              <div class="home__bottom__item__left">
                <h3 class="home__bottom__title">
                  Социальные <br />
                  сети
                </h3>
                <span
                  class="home__bottom__link"
                  @click="
                    () => {
                      $router.push('/edit/social');
                      this.GAEvent('socials_edit');
                    }
                  "
                  >Редактировать</span
                >
              </div>
              <div class="home__bottom__item__right">
                <img :src="require('../assets/img/telegram.png')" />
              </div>
            </div>
          </div>
          <div class="home__faq">
            <h3 class="home__faq__title">FAQ</h3>
            <PFAQ
              question="Как изменить шаблон?"
              :answer="
                'Перейдите в <a href=\'/edit\'>настройки страницы</a>, нажав кнопку «Редактировать». Перейдите  в компонент <a href=\'/templates\'>выбора шаблонов.</a> Вы можете выбрать дизайн страницы из готовых тем. Воспользуйтесь «Предпросмотром», чтобы увидеть, как будет выглядеть ваша страница для гостей и других пользователей.'
              "
            />
            <PFAQ
              question="Как получить эксклюзивный шаблон ALL STARS?"
              :answer="
                'Эксклюзивный шаблон доступен номинантам программы ALL STARS. Подробнее о проекте и участии <a href=&quot;https://www.amway.ru/allstars&quot; target=&quot;_blank&quot;>здесь</a>'
              "
              v-if="!$store.state.userTypes.vip"
            />
            <PFAQ
              question="Как выбирать и редактировать компоненты?"
              :answer="
                'Изменить компоненты можно, перейдя в <a href=\'/edit\'>настройки страницы.</a> Для этого нажмите кнопку «Редактировать». Здесь вы можете подключить или отключить компоненты, передвинув соответствующий тумблер, и редактировать их. Информацию о каждом можно узнать, нажав знак вопроса. Активные компоненты выделены зелёным. К Личной странице можно подключить фон, блоки с продуктами, личными достижениями, мероприятиями Amway и сертификатами, а также указать в ней контактную информацию и ссылки на социальные сети.'
              "
            />
            <PFAQ
              v-if="moreFAQ || $store.state.userTypes.vip"
              question="Как сменить свою фотографию на аватаре?"
              :answer="
                'Сменить фотографию можно, нажав кнопку «Редактировать» в <a href=\'/edit/profile\'>блоке «Контакты»</a>. Загрузите фотографию размером не более 2 МБ в форматах JPEG или PNG. Выберите миниатюру таким образом, чтобы на аватаре было видно ваше лицо. Старайтесь использовать изображения в хорошем качестве.'
              "
            />
            <PFAQ
              v-if="moreFAQ"
              question="Как сменить фон на странице?"
              :answer="
                'Перейдите в <a href=\'/edit\'>настройки страницы</a>, нажав кнопку «Редактировать». Перейдите к редактированию компонента <a href=\'/edit/backgrounds\'>«Фон страницы»</a>. Выберите фон вашей страницы среди представленных на сайте изображений. Поверх фона страницы будут отображены ваши контактные данные. '
              "
            />
            <PFAQ
              v-if="moreFAQ"
              question="Как загружать свои сертификаты?"
              :answer="
                'Перейдите в <a href=\'/edit\'>настройки страницы</a>, нажав кнопку «Редактировать». Перейдите к редактированию компонента <a href=\'/edit/certificates\'>«Мои сертификаты»</a>. Загрузите фотографии или сканы сертификатов, которые подтверждают ваши профессиональные достижения. Для загрузки доступны изображения в форматах JPEG или PDF размером не более 2 МБ, а также PDF-файлы размером не более 10 МБ. '
              "
            />
            <PFAQ
              v-if="moreFAQ"
              question="Как удалить сертификат?"
              :answer="
                'Вы всегда можете удалить любой загруженный сертификат. Для этого наведите курсор на изображение необходимого сертификата и нажмите на иконку «Корзины».'
              "
            />
            <PFAQ
              v-if="moreFAQ"
              question="Как добавлять ссылки на свои социальные сети?"
              :answer="
                'Перейдите в <a href=\'/edit\'>настройки страницы</a>, нажав кнопку «Редактировать». Перейдите к редактированию компонента <a href=\'/edit/social\'>«Социальные сети»</a>. Вы можете добавить до 9 социальных сетей. Вставьте ссылки на свои страницы или имя пользователя социальной сети. Проверьте их, иначе социальная сеть не будет подключена правильно.'
              "
            />
            <PFAQ
              v-if="moreFAQ"
              question="Как опубликовать страницу?"
              :answer="
                'После создания Личной страницы её нужно опубликовать. Проверить и изменить статус можно прямо со <a href=\'/\'>страницы конструктора</a> с помощью соответствующей кнопки. Если страница не опубликована, другие пользователи не смогут её увидеть. В Личной странице указан её адрес, которым можно поделиться, скопировав его.'
              "
            />
            <PFAQ
              v-if="moreFAQ"
              question="Как посмотреть свою статистику?"
              :answer="
                '<a href=\'/statistics\'>Кнопка для просмотра статистики</a> Личной страницы размещена в ее верхней части на фоне. Вы можете узнать количество посетителей, в том числе уникальных, их пол, возраст, а также сколько людей и в какое время посещали вашу страницу. Можно посмотреть статистику за разные временные отрезки: сегодня, вчера, неделя, месяц и т. д.'
              "
            />
            <PFAQ
              v-if="moreFAQ"
              question="Как продвигать свою Личную страницу?"
              answer="У вашей страницы есть ссылка, которой можно делиться в социальных сетях. Отправляйте её друзьям, партнёрам и потенциальным клиентам. Если новый клиент зарегистрируется, перейдя по ссылке с вашей страницы, вы автоматически становитесь его контактным лицом. Не забудьте проверить, опубликована ли ваша страница, иначе другие люди не смогут её увидеть."
            />
            <button
              class="home__faq__more"
              v-if="!moreFAQ"
              @click="moreFAQ = true"
            >
              Ещё
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CSwitch from "../components/CSwitch";
import Migration from "../components/Migration.vue";
import PFAQ from "../components/PFAQ";

export default {
  name: "Home2",
  components: { PFAQ, CSwitch, Migration },
  data() {
    return {
      template: this.$store.state.page.template,
      profileData: this.$store.state.page.components.find(
        c => c.type === "Profile"
      ).content,
      published: !this.$store.state.page.enabled,
      pageBaseUrl: this.$store.state.isKZ
        ? process.env.VUE_APP_PAGE_KZ
        : process.env.VUE_APP_PAGE,
      isTablet: window.innerWidth < 1024 && window.innerWidth >= 768,
      isMobile: window.innerWidth < 768,
      moreFAQ: false
    };
  },
  computed: {
    ...mapGetters(["getComponentByName"]),
    imgLink() {
      if (this.profileData.avatar.indexOf("amwaypersonalpage") > -1) {
        return this.profileData.avatar;
      } else {
        return `${this.host}${this.profileData.avatar}`;
      }
    },
    templateConstructorData() {
      return this.$store.state.constructorData.templates[4];
    },
    templateCoverConstructorData() {
      let str = this.$store.state.constructorData.templates[4].cover.replace(
        /api/,
        ""
      );
      return str;
    },
    host() {
      return process.env.VUE_APP_API_ROOT;
    }
  },
  watch: {
    published(value) {
      this.$store.dispatch("setPageEnabled", !value);
      if (!value) {
        this.GAEvent(
          "profile-publication_status",
          "published_profile",
          this.$store.state.page.url
        );
      } else {
        this.GAEvent(
          "profile-publication_status",
          "unpublished_profile",
          this.$store.state.page.url
        );
      }
    }
  },
  methods: {
    copy(str) {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$eventBus.$emit("serverSyncSuccess", {
        msg: "Ссылка скопирована"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/vars";

.page__wrapper {
  background: #efefef;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  @media #{$tablet} {
    padding: 0;
    background: #ffffff;
  }
}

.home {
  background: #ffffff;
  max-width: 1280px;
  border-radius: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  @media #{$tablet} {
    padding: 15px 30px;
    border-radius: 0;
  }
  @media #{$mobile} {
    padding: 35px 0 0;
  }
  &__header {
    max-width: 1280px;
    width: 100%;
    padding: 0 70px;
    display: flex;
    flex-direction: column;
    @media #{$tablet} {
      max-width: 100%;
      padding: 0 60px;
    }
    @media #{$mobile} {
      padding: 0 15px;
      flex-direction: column-reverse;
    }
  }
  &__top {
    height: 405px;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    align-content: center;
    padding: 0 70px 60px;
    @media #{$tablet} {
      padding: 0 30px 45px;
      height: 300px;
      border-radius: 12px 12px 0 0;
    }
    @media #{$mobile} {
      padding: 0 15px 25px;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-start;
      border-radius: 0;
    }
    .pBtn--blue {
      @media #{$mobile} {
        width: 100%;
      }
    }
    &__title {
      font-size: 48px;
      line-height: 120%;
      font-weight: bold;
      padding: 0;
      margin: 0 0 30px;
      text-align: left;
      @media #{$tablet} {
        text-align: left;
        font-size: 34px;
        margin-bottom: 15px;
      }
      @media #{$mobile} {
        padding: 35px 0 0;
      }
    }

    &__template_name {
      font-size: 16px;
      line-height: 120%;
      font-weight: 500;
      margin-bottom: 10px;
      @media #{$mobile} {
        margin: 0;
      }
    }
  }

  &__middle {
    background: #26cc73;
    padding: 45px 70px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &--unpublished {
      background: #f2f2f2;
      border: 1px solid #cccccc;
    }
    @media #{$tablet} {
      flex-wrap: wrap;
      padding: 45px 20px;
    }
    .pBtn--blue {
      font-size: 18px;
      padding: 18px;
      @media #{$tablet} {
        order: 1;
      }
    }

    .pBtn--grey-2 {
      @media #{$tablet} {
        order: 2;
      }
    }
  }

  &__link {
    display: flex;
    align-items: center;
    @media #{$tablet} {
      order: 4;
      margin-top: 30px;
    }
    @media #{$mobile} {
      width: 100%;
    }
    &__place {
      border: 1px solid #ffffff;
      padding: 16px 26px;
      color: #ffffff;
      border-radius: 5px;
      margin-right: 24px;
      .home__middle--unpublished & {
        color: #303333;
        border-color: #303333;
      }
      @media #{$mobile} {
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        width: 100%;
        margin-right: 0;
        position: relative;
        padding-right: 70px;
      }
    }
  }

  &__icon_copy {
    position: absolute;
    right: 10px;
    cursor: pointer;
  }

  &__copy {
    color: #ffffff;
    font-size: 18px;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    cursor: pointer;
    .home__middle--unpublished & {
      color: #303333;
    }
    span {
      margin-right: 10px;
      /deep/ .home__middle--unpublished & svg path {
        fill: #303333;
      }
    }
  }

  &__published {
    color: #ffffff;
    text-transform: uppercase;
    font-size: 18px;
    display: flex;
    align-items: center;
    .home__middle--unpublished & {
      color: #303333;
    }
    @media #{$tablet} {
      order: 3;
    }
    .switch {
      margin-right: 20px;
    }
  }

  &__bottom {
    padding: 60px 70px;
    @media #{$tablet} {
      padding: 20px 0;
    }
    @media #{$mobile} {
      padding: 0 15px;
    }
    &__items {
      display: flex;
      justify-content: space-between;
      margin-bottom: 60px;
      @media #{$tablet} {
        margin-bottom: 45px;
      }
      @media #{$mobile} {
        flex-direction: column;
      }
    }
    &__item {
      background: #f2f2f2;
      border: 1px solid #cccccc;
      border-radius: 12px;
      padding: 40px 30px;
      display: flex;
      justify-content: space-between;
      width: 520px;
      @media #{$tablet} {
        width: calc(50% - 11px);
        padding: 30px 22px;
      }
      @media #{$mobile} {
        width: 100%;
        padding: 22px;
        height: 160px;
        margin-bottom: 15px;
      }
      &__left {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      }
      &__right {
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 150px;
          height: auto;
          @media #{$tablet} {
            width: 108px;
          }
          @media #{$mobile} {
            width: 90px;
          }
        }
      }
    }
    &__title {
      color: #303333;
      line-height: 120%;
      font-size: 32px;
      font-weight: bold;
      margin: 0;
      @media #{$tablet} {
        font-size: 24px;
      }
    }
    &__link {
      color: #3a5eec;
      font-size: 18px;
      text-transform: uppercase;
      font-weight: 500;
      cursor: pointer;
      @media #{$tablet} {
        font-size: 15px;
      }
    }
  }
  &__avatar {
    border-radius: 100%;
  }

  &__faq {
    &__title {
      color: #000000;
      font-size: 24px;
      padding-left: 30px;
      @media #{$mobile} {
        font-size: 28px;
        text-align: center;
        padding-left: 0;
      }
    }

    &__more {
      background: transparent;
      border: none;
      margin: 15px 0;
      text-transform: uppercase;
      font-size: 18px;
      font-weight: bold;
      width: 100%;
      cursor: pointer;
    }
  }
  &__sub_mid {
    padding: 30px 15px;
    .pBtn--grey-2 {
      border: 1px solid #cccccc;
      width: 100%;
      justify-content: center;
    }
  }
}
</style>
